export const i18nEn = {
  currency: "$"
};

export const i18nPt = {
  currency: "R$"
}